import React from "react";
import { FiGift, FiX, FiZap, FiCalendar, FiCpu, FiDollarSign } from "react-icons/fi";

const NewUserTrialPopup = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-slate-950/80 backdrop-blur-sm transition-opacity duration-300">
      <div className="relative w-full max-w-lg overflow-hidden rounded-3xl bg-slate-900 border border-slate-800 shadow-2xl shadow-orange-500/10 text-white p-8 md:p-10 transform transition-all duration-300 scale-100">
        {/* Glow Effects */}
        <div className="absolute -top-24 -left-24 w-48 h-48 bg-amber-500/20 rounded-full blur-3xl pointer-events-none"></div>
        <div className="absolute -bottom-24 -right-24 w-48 h-48 bg-orange-500/20 rounded-full blur-3xl pointer-events-none"></div>

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-5 right-5 p-2 rounded-full text-slate-400 hover:text-white hover:bg-slate-800 transition-all duration-200"
          aria-label="Đóng"
        >
          <FiX className="text-xl" />
        </button>

        {/* Content Container */}
        <div className="flex flex-col items-center text-center">
          {/* Animated Gift Icon */}
          <div className="relative flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-amber-400 to-orange-500 shadow-lg shadow-orange-500/30 mb-6 transform hover:rotate-12 transition-transform duration-300">
            <FiGift className="text-white text-4xl" />
            <span className="absolute -top-1 -right-1 flex h-4 w-4">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-4 w-4 bg-orange-500"></span>
            </span>
          </div>

          {/* Heading */}
          <h2 className="text-2xl md:text-3xl font-extrabold tracking-tight bg-gradient-to-r from-amber-300 via-orange-400 to-orange-500 bg-clip-text text-transparent mb-3">
            Quà Tặng Đặc Quyền Premium!
          </h2>
          
          <p className="text-slate-300 text-sm md:text-base max-w-sm mb-6 leading-relaxed">
            Chúc mừng bạn đã gia nhập đại gia đình <span className="font-bold text-amber-400">AutoWork</span>! Tài khoản của bạn đã được tự động kích hoạt <span className="font-bold text-orange-400">1 ngày trải nghiệm Premium hoàn toàn miễn phí</span>.
          </p>

          {/* Features List */}
          <div className="w-full bg-slate-950/50 rounded-2xl p-5 border border-slate-800/80 text-left space-y-4 mb-8">
            <h3 className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-2">
              Các tính năng Premium đang mở khóa:
            </h3>
            
            <div className="flex items-start">
              <div className="flex-shrink-0 mt-0.5 p-1 rounded-md bg-amber-500/10 text-amber-400">
                <FiCpu className="text-sm" />
              </div>
              <p className="ml-3 text-slate-300 text-sm">
                <strong className="text-slate-200">Tạo bài viết AI</strong> tự động, tối ưu hóa nội dung đa kênh không giới hạn.
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 mt-0.5 p-1 rounded-md bg-amber-500/10 text-amber-400">
                <FiCalendar className="text-sm" />
              </div>
              <p className="ml-3 text-slate-300 text-sm">
                <strong className="text-slate-200">Lên lịch tự động</strong> đăng bài lên Fanpage Facebook, Zalo OA và Website WordPress tiện lợi.
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 mt-0.5 p-1 rounded-md bg-amber-500/10 text-amber-400">
                <FiDollarSign className="text-sm" />
              </div>
              <p className="ml-3 text-slate-300 text-sm">
                <strong className="text-slate-200">Hệ thống Affiliate tích hợp</strong>, hỗ trợ chia sẻ doanh thu và gia tăng thu nhập thụ động bền vững.
              </p>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 mt-0.5 p-1 rounded-md bg-amber-500/10 text-amber-400">
                <FiZap className="text-sm" />
              </div>
              <p className="ml-3 text-slate-300 text-sm">
                Đầy đủ <strong className="text-slate-200">tốc độ & băng thông cao</strong> để tạo và đăng bài nhanh gấp 5 lần.
              </p>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 w-full">
            <button
              onClick={onClose}
              className="flex-1 py-3 px-6 rounded-xl font-bold bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white shadow-lg shadow-orange-500/20 hover:shadow-orange-500/40 transform hover:-translate-y-0.5 transition-all duration-200"
            >
              Trải nghiệm ngay
            </button>
            <button
              onClick={onClose}
              className="py-3 px-6 rounded-xl font-medium bg-slate-800 hover:bg-slate-700 text-slate-300 hover:text-white transition-colors duration-200 border border-slate-700/80"
            >
              Bỏ qua
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewUserTrialPopup;
